module.exports = __webpack_public_path__ + "static/education_card_img1@2x-f3144953966f6d9d153ce4a66146a388.jpg";